/* Sechi – tendina «Negozio online» (mega menu), desktop con mouse:
   - al passaggio del mouse si apre la tendina con i reparti (il tema la aprirebbe solo al clic);
   - al CLIC sulla voce si va alla pagina dei reparti (Daniele 19/09 15:32: «quando clicco non succede nulla,
     portami alla pagina categorie»): l'URL è quello della voce di menu (data-sechi-url) o, in mancanza, /pages/negozio-online.
   Su touch/telefono resta il comportamento del tema (tocco = apre/chiude). */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
  var URL_VOCI = { 'negozio online': '/pages/negozio-online', 'shop': '/pages/negozio-online' };
  document.querySelectorAll('details.mega-menu').forEach(function (d) {
    var t = null;
    var li = d.closest('li') || d;
    var summary = d.querySelector('summary');
    li.addEventListener('mouseenter', function () { clearTimeout(t); d.open = true; });
    li.addEventListener('mouseleave', function () { t = setTimeout(function () { d.open = false; }, 250); });
    if (summary) summary.addEventListener('click', function (e) {
      var nome = (summary.textContent || '').trim().toLowerCase();
      var url = summary.getAttribute('data-sechi-url') || URL_VOCI[nome];
      if (url) { e.preventDefault(); window.location.href = url; }
    });
    var content = d.querySelector('.mega-menu__content');
    if (content) { content.addEventListener('mouseenter', function () { clearTimeout(t); }); content.addEventListener('mouseleave', function () { t = setTimeout(function () { d.open = false; }, 250); }); }
  });
})();

/* Sechi – consegna stimata (portata da Onautica il 19/09/2026, semplificata). Legge il riquadro .sechi-disp e scrive:
   ritiro in negozio (pronto oggi/domani/da …), consegna a casa (data min–max) e il conto alla rovescia sul cutoff.
   Regole negozio: spedizioni lun–ven, ordine entro le 12:00 parte in giornata; magazzino = 0-1 gg + corriere 2-4 gg;
   su ordinazione = lead (default 3) … lead+2 gg + corriere; in arrivo = dalla data di arrivo + 0-1 + corriere.
   Il ritiro segue gli orari del negozio (lun–ven, sab mattina). Festività italiane 2026-2027. */
(function () {
  var FEST = ['2026-01-01','2026-01-06','2026-04-06','2026-04-25','2026-05-01','2026-05-25','2026-06-02','2026-08-15','2026-11-01','2026-12-08','2026-12-25','2026-12-26',
              '2027-01-01','2027-01-06','2027-03-29','2027-04-25','2027-05-01','2027-06-02','2027-08-15','2027-11-01','2027-12-08','2027-12-25','2027-12-26'];
  var MESI = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
  var GG = ['dom','lun','mar','mer','gio','ven','sab'];
  var CUTOFF = 12 * 60;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function chiave(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function roma() { var s = new Date().toLocaleString('en-CA', { timeZone: 'Europe/Rome', hour12: false }); var m = s.match(/(\d+)-(\d+)-(\d+)[,\s]+(\d+):(\d+)/); return { d: new Date(+m[1], +m[2] - 1, +m[3]), min: (+m[4] % 24) * 60 + (+m[5]) }; }
  function festivo(d) { return FEST.indexOf(chiave(d)) !== -1; }
  function lavorativo(d) { var w = d.getDay(); return w >= 1 && w <= 5 && !festivo(d); }
  function apertura(d) { var w = d.getDay(); return w >= 1 && w <= 6 && !festivo(d); }
  function domani(d) { var x = new Date(d.getTime()); x.setDate(x.getDate() + 1); return x; }
  function piu(d, n, test) { var x = new Date(d.getTime()); for (var i = 0; i < n;) { x.setDate(x.getDate() + 1); if (test(x)) i++; } return x; }
  function prossimo(d, test) { var x = new Date(d.getTime()); while (!test(x)) x.setDate(x.getDate() + 1); return x; }
  function fmt(d) { return GG[d.getDay()] + ' ' + d.getDate() + ' ' + MESI[d.getMonth()]; }
  function stesso(a, b) { return chiave(a) === chiave(b); }
  function calcola(box) {
    var stato = box.getAttribute('data-stato'); if (!stato || stato === 'esaurito') return;
    // 23/09 21:43 (Daniele): articolo non in negozio = stesse regole di Onautica («backorder»): il fornitore ce lo fa arrivare
    // in `lead` giorni lavorativi (default 7 come Onautica, o custom.lead_giorni), poi corriere 2-4 gg. Il RITIRO in negozio è
    // pronto quando la merce arriva da noi: stessa data meno i giorni di corriere (= partenza + lead). Dropship (parte dal
    // fornitore) = come magazzino, 0-1 gg + corriere, come su Onautica.
    var lead = parseInt(box.getAttribute('data-lead'), 10) || 7;
    var arrivo = box.getAttribute('data-arrivo');
    var dropship = box.getAttribute('data-dropship') === 'true';
    var ora = roma(), oggi = ora.d;
    var partenza = (lavorativo(oggi) && ora.min < CUTOFF) ? oggi : prossimo(domani(oggi), lavorativo);
    var prepMin = 0, prepMax = 1;
    // 21:50 Daniele: la spedizione parte SOLO quando la merce è arrivata da noi: arrivo in negozio = partenza + lead
    // (dropship: + 3 gg di corriere fornitore→negozio), poi corriere 2-4 gg al cliente. Il ritiro è alla data di arrivo.
    if (stato === 'ordinazione') { prepMin = dropship ? 3 : lead; prepMax = prepMin; }
    if (stato === 'arrivo' && arrivo) { var a = new Date(arrivo + 'T00:00:00'); if (a > partenza) partenza = prossimo(a, lavorativo); }
    var partMin = piu(partenza, prepMin, lavorativo), partMax = piu(partenza, prepMax, lavorativo);
    // 29/09/2026 Daniele (lotto 15 olive): dropship FSP/Maritex con giorni fissi, dal metafield variante custom.consegna.
    var consegna = box.getAttribute('data-consegna') || '', ritiroFisso = null;
    if (stato === 'ordinazione' && /^(fsp-settimanale|fsp-rapido|maritex)$/.test(consegna)) {
      var arr;
      if (consegna === 'fsp-rapido') arr = piu(oggi, 1, lavorativo);
      else {
        var gCut = consegna === 'maritex' ? 3 : 2, x = new Date(oggi.getTime());   // mercoledì / martedì, entro le 10:00
        if (!(x.getDay() === gCut && ora.min <= 600)) { x = domani(x); while (x.getDay() !== gCut) x = domani(x); }
        arr = prossimo(domani(x), lavorativo);
      }
      partMin = partMax = consegna === 'maritex' ? arr : piu(arr, 1, lavorativo);
      ritiroFisso = 'pronto da ' + fmt(arr) + (consegna === 'maritex' ? '' : ' dalle 15:40');
    }
    var consMin = piu(partMin, 2, lavorativo), consMax = piu(partMax, 4, lavorativo);
    var elC = box.querySelector('.sechi-eta-consegna');
    if (elC) elC.textContent = stesso(consMin, consMax) ? fmt(consMin) : fmt(consMin) + ' – ' + fmt(consMax);
    var elR = box.querySelector('.sechi-eta-ritiro');
    if (elR) {
      if (stato === 'magazzino') {
        var chiusura = oggi.getDay() === 6 ? 13 * 60 : 19 * 60;   // sabato solo mattina
        var pronto = (apertura(oggi) && ora.min < chiusura) ? oggi : prossimo(domani(oggi), apertura);
        elR.textContent = stesso(pronto, oggi) ? 'pronto oggi' : (stesso(pronto, domani(oggi)) ? 'pronto domani' : 'pronto da ' + fmt(pronto));
      } else {
        // ritiro = quando la merce arriva in negozio: backorder = partenza + lead; dropship (parte dal fornitore) = partenza + 3 gg
        // lavorativi di corriere fornitore→negozio; «in arrivo» = data d'arrivo.
        elR.textContent = ritiroFisso || ('pronto da ' + fmt(prossimo(partMin, apertura)) + ' circa');
      }
    }
    var elT = box.querySelector('.sechi-disp__timer');
    if (elT) {
      if (stato === 'magazzino' && lavorativo(oggi) && ora.min < CUTOFF) { var r = CUTOFF - ora.min; elT.querySelector('.sechi-eta-timer').textContent = Math.floor(r / 60) + ' h ' + pad(r % 60) + ' min'; elT.hidden = false; }
      else elT.hidden = true;
    }
  }
  function tutti() { document.querySelectorAll('.sechi-disp').forEach(calcola); }
  window.sechiEta = tutti;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutti); else tutti();
  var tt = null;
  new MutationObserver(function () { if (tt) return; tt = setTimeout(function () { tt = null; tutti(); }, 120); }).observe(document.body, { childList: true, subtree: true });
  setInterval(tutti, 60000);
})();

/* Sechi – esplosi Ibea (01/10/2026, Daniele: «per ingrandire dovrei cliccare sull'immagine, non sulla scritta»).
   Ogni disegno .ibx delle pagine esploso: lente in alto a destra; al tocco il disegno si apre a tutto schermo, grande e
   scorrevole col dito, con i numeri ancora cliccabili (cerchi rossi → scheda del ricambio). Pulsanti − / + / ×, Esc e il tasto
   Indietro del telefono chiudono. Su schermo largo con mouse il clic su un numero va subito al ricambio; sul telefono il primo
   tocco ingrandisce (a 345 px i numeri del disegno sono troppo piccoli per il dito). */
(function () {
  var disegni = document.querySelectorAll('.ibx');
  if (!disegni.length) return;
  var LENTE = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 19" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M4.667 7.94a.5.5 0 0 1 .499-.501l5.534-.014a.5.5 0 1 1 .002 1l-5.534.014a.5.5 0 0 1-.5-.5" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M7.926 4.665a.5.5 0 0 1 .501.498l.014 5.534a.5.5 0 1 1-1 .003l-.014-5.534a.5.5 0 0 1 .499-.501" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12.832 3.03a6.931 6.931 0 1 0-9.802 9.802 6.931 6.931 0 0 0 9.802-9.802M2.323 2.323a7.931 7.931 0 0 1 11.296 11.136l4.628 4.628a.5.5 0 0 1-.707.707l-4.662-4.662A7.932 7.932 0 0 1 2.323 2.323" clip-rule="evenodd"/></svg>';
  var PASSI = [1, 1.5, 2, 3, 4];
  var ov = null, scroller = null, box = null, scala = 0;
  function largo() { return window.matchMedia('(min-width: 750px) and (hover: hover)').matches; }
  function applica(fx, fy) {
    var w = Math.round(scroller.clientWidth * PASSI[scala]);
    box.style.width = w + 'px';
    scroller.scrollLeft = fx * w - scroller.clientWidth / 2;
    scroller.scrollTop = fy * box.offsetHeight - scroller.clientHeight / 2;
  }
  function centro() { return [(scroller.scrollLeft + scroller.clientWidth / 2) / box.offsetWidth, (scroller.scrollTop + scroller.clientHeight / 2) / (box.offsetHeight || 1)]; }
  function chiudi(daStoria) {
    if (!ov) return;
    ov.parentNode.removeChild(ov); ov = null; document.documentElement.style.overflow = '';
    if (!daStoria && history.state && history.state.sechiIbx) history.back();
  }
  function apri(ibx, fx, fy) {
    if (ov) return;
    var h = ibx.previousElementSibling; while (h && h.tagName !== 'H2') h = h.previousElementSibling;
    var numeri = ibx.querySelectorAll('a').length;
    ov = document.createElement('div'); ov.className = 'ibx-ov'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true');
    ov.innerHTML = '<div class="ibx-ov__bar"><span class="ibx-ov__tit"><strong></strong><small></small></span>' +
      '<button type="button" data-z="-1" aria-label="Rimpicciolisci">&minus;</button><button type="button" data-z="1" aria-label="Ingrandisci">+</button>' +
      '<button type="button" data-chiudi aria-label="Chiudi">&times;</button></div><div class="ibx-ov__scroll"></div>';
    ov.querySelector('.ibx-ov__tit strong').textContent = h ? h.textContent : 'Esploso';
    ov.querySelector('.ibx-ov__tit small').textContent = numeri ? 'Tocca un cerchio rosso per aprire il ricambio' : 'Scorri col dito per vedere tutto il disegno';
    scroller = ov.querySelector('.ibx-ov__scroll');
    box = ibx.cloneNode(true);
    var b = box.querySelector('.ibx-zoom-btn'); if (b) b.parentNode.removeChild(b);
    var img = box.querySelector('img'); if (img) img.removeAttribute('loading');
    scroller.appendChild(box);
    document.body.appendChild(ov); document.documentElement.style.overflow = 'hidden';
    scala = largo() ? 1 : 3;
    applica(fx, fy);
    if (img && !img.complete) img.addEventListener('load', function () { if (ov) applica(fx, fy); });
    ov.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (a && a.getAttribute('href').charAt(0) === '#') {   // pezzo non a catalogo: si chiude e si va alla riga della lista
        e.preventDefault(); chiudi(true);
        var riga = document.getElementById(a.getAttribute('href').slice(1));
        if (riga) { riga.scrollIntoView({ block: 'center' }); riga.style.background = '#fbe3d9'; }
        return;
      }
      var bt = e.target.closest('button'); if (!bt) return;
      if (bt.hasAttribute('data-chiudi')) { chiudi(false); return; }
      var c = centro(); scala = Math.max(0, Math.min(PASSI.length - 1, scala + parseInt(bt.getAttribute('data-z'), 10))); applica(c[0], c[1]);
    });
    try { history.pushState({ sechiIbx: 1 }, ''); } catch (err) {}
    ov.querySelector('[data-chiudi]').focus({ preventScroll: true });
  }
  window.addEventListener('popstate', function () { if (ov) chiudi(true); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov) chiudi(false); });
  disegni.forEach(function (ibx) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'ibx-zoom-btn'; b.setAttribute('aria-label', 'Ingrandisci il disegno'); b.innerHTML = LENTE;
    ibx.appendChild(b);
    ibx.addEventListener('click', function (e) {
      var lente = e.target.closest('.ibx-zoom-btn');
      if (!lente && e.target.closest('a') && largo()) return;   // computer: il numero porta subito al ricambio
      e.preventDefault();
      var r = ibx.getBoundingClientRect();
      var fx = lente ? 0.5 : (e.clientX - r.left) / r.width, fy = lente ? 0.5 : (e.clientY - r.top) / r.height;
      apri(ibx, Math.min(1, Math.max(0, fx)), Math.min(1, Math.max(0, fy)));
    });
  });
})();

/* Sechi – selettore modelli (collezione «Minitransporter Ibea e ricambi», 01/10/2026, proposta B scelta da Daniele).
   Nella descrizione della collezione la tendina è un <details class="sechi-modelli"> con i link (funziona anche senza JavaScript);
   qui diventa la tendina vera del telefono (<select>, con i gruppi dai titoli .sechi-modelli__gruppo):
   scelgo il modello → si apre la sua pagina esploso. Tornando indietro la tendina riparte da «Scegli il tuo modello». */
(function () {
  document.querySelectorAll('details.sechi-modelli').forEach(function (d) {
    var sel = document.createElement('select');
    sel.className = 'sechi-modelli-select';
    sel.setAttribute('aria-label', 'Scegli il tuo modello');
    var o0 = document.createElement('option');
    o0.value = ''; o0.textContent = 'Scegli il tuo modello'; o0.disabled = true; o0.selected = true;
    sel.appendChild(o0);
    var gruppo = null;
    d.querySelectorAll('.sechi-modelli__gruppo, a[href]').forEach(function (el) {
      if (el.tagName !== 'A') { gruppo = document.createElement('optgroup'); gruppo.label = el.textContent.trim(); sel.appendChild(gruppo); return; }
      var o = document.createElement('option');
      o.value = el.getAttribute('href'); o.textContent = el.textContent.replace(/\s+/g, ' ').trim();
      (gruppo || sel).appendChild(o);
    });
    if (sel.options.length < 2) return;
    sel.addEventListener('change', function () { if (sel.value) window.location.href = sel.value; });
    window.addEventListener('pageshow', function () { sel.selectedIndex = 0; });
    d.parentNode.replaceChild(sel, d);
  });
})();

/* Sechi – tasto «Macchina vecchia? Vedi modello» (selettore Ibea, 01/10/2026, Daniele 09:53: «la gente non legge»).
   Il tasto è un <details class="sechi-vecchia"> con l'elenco dei modelli fuori produzione per serie (funziona anche senza
   JavaScript). Con JavaScript: porta in vista la tendina dei modelli (scroll dolce), le dà il focus e la apre già posizionata
   sui fuori produzione (select.showPicker); se il browser non sa aprirla da solo si apre l'elenco sotto il tasto. */
(function () {
  document.querySelectorAll('details.sechi-vecchia').forEach(function (d) {
    var box = d.closest('.sechi-selettore') || document;
    var sel = box.querySelector('select.sechi-modelli-select');
    var sum = d.querySelector('summary');
    if (!sel || !sum) return;
    var primo = null;
    for (var i = 0; i < sel.children.length; i++) { var g = sel.children[i]; if (g.tagName === 'OPTGROUP' && /fuori produzione/i.test(g.label)) { primo = g; break; } }
    if (!primo) return;
    var segno = document.createElement('option');
    segno.disabled = true; segno.value = ''; segno.textContent = '— Macchine fuori produzione —';
    sel.insertBefore(segno, primo);
    sel.addEventListener('blur', function () { if (sel.selectedIndex === segno.index) sel.selectedIndex = 0; });
    sum.addEventListener('click', function (e) {
      if (d.open) return;                       // il secondo tocco chiude l'elenco di riserva
      e.preventDefault();
      if (typeof sel.showPicker !== 'function') { d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      sel.selectedIndex = segno.index;          // la tendina si apre sui fuori produzione
      sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () {
        try { sel.focus({ preventScroll: true }); sel.showPicker(); }
        catch (err) { sel.selectedIndex = 0; d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }, 450);
    });
  });
})();
